module.exports = __webpack_public_path__ + "img/activity-yq1.f6ede7c2.png";